import React, { memo, useState, useEffect } from 'react';
import { Formik, Form } from 'formik';
import UploadImgComponent from '../../../../components/Dashboard-res/CommonComponent/UploadImgComponent';
import arrow_icon from '../../../../images/icons/BlueArrow.svg';
import DocImage from '../../../../images/icons/docImage.svg';
import MaleImage from '../../../../images/icons/male.svg';
import Female from '../../../../images/icons/UserKycIcons/female_icon.svg';
import CommonInput from '../../../../components/Dashboard-res/CommonComponent/CommonInput';
import { useFormikContext } from 'formik';
import CommonDatePicker from '../../../../components/Dashboard-res/CommonComponent/CommonDatePicker';
import get from 'lodash/get';

import CommonPincode from '../../../../components/Dashboard-res/CommonComponent/CommonPincode';
import CommonSelect from '../../../../components/Dashboard-res/CommonComponent/CommonSelect';
import GlobalUploadComp from '../../../../common/components/GlobalUploadComp/GlobalUploadComp';
import ResidentialAdress from '../../ResidentialAddress/ResidentialAdress';
import '../../AadharPage/Aadhar.css';
import PopUp from '../../../../common/components/PopUp/PopUp';
import { useFormikWizard } from 'formik-wizard';
import {
  UserKycUpload,
  UserKycOcr,
  UploadFileToS3,
  UserKycSave,
  UserKycVarifyDetails,
  GETAPI
} from '../../../../common/constants/api';
import initialImg from '../../../../images/icons/upload_new.svg';
import { getApplicantionInfo } from '../../../../common/utils/applicantionInfo';
import common_gender from '../../../../images/icons/UserKycIcons/common_gender.svg';
import mb_reupload from '../../../../images/icons/mb_upload.svg';
import { ShowGetImage } from '../../../../common/components/ShowGetImage/ShowGetImage';
import moment from 'moment';

import * as Yup from 'yup';
const validationSchema = Yup.object().shape({
  gender: Yup.string().when('SkipAadhar', {
    is: false,
    then: Yup.string().required('Required')
  }),
  name: Yup.string().when('SkipAadhar', {
    is: false,
    then: Yup.string()
      .required('Required')
      .min(3, 'Too Short!')
  }),

  aadhar_no: Yup.string().when('SkipAadhar', {
    is: false,
    then: Yup.string()
      .required('Required')
      .length(12, 'Aadhar shuould be 12 digit Number!')
  }),
  address_line_1: Yup.string().when('SkipAadhar', {
    is: false,
    then: Yup.string()
      .required('Required')
      .min(10, 'Too Short')
  }),
  city: Yup.string().when('SkipAadhar', {
    is: false,
    then: Yup.string()
      .required('Required')
      .min('2', 'Too Short!')
  }),
  state: Yup.object().shape({
    value: Yup.string().when('SkipAadhar', {
      is: false,
      then: Yup.string().required('Required')
    })
  }),
  pincode: Yup.string().when('SkipAadhar', {
    is: false,
    then: Yup.string()
      .required('Required')
      .length(6, 'Must be 6 Digit Nmber!')
  }),
  date: Yup.object().shape({
    value: Yup.string().when('SkipAadhar', {
      is: false,
      then: Yup.string().required('Required')
    })
  }),
  month: Yup.object().shape({
    value: Yup.string().when('SkipAadhar', {
      is: false,
      then: Yup.string().required('Required')
    })
  }),
  year: Yup.object().shape({
    value: Yup.string().when('SkipAadhar', {
      is: false,
      then: Yup.string().required('Required')
    })
  })
});
let StateList = [
  'Andhra Pradesh',
  'Arunachal Pradesh',
  'Assam',
  'Bihar',
  'Chhattisgarh',
  'Goa',
  'Gujarat',
  'Haryana',
  'Himachal Pradesh',
  'Jammu and Kashmir',
  'Jharkhand',
  'Karnataka',
  'Kerala',
  'Madhya Pradesh',
  'Maharashtra',
  'Manipur',
  'Meghalaya',
  'Mizoram',
  'Nagaland',
  'Odisha',
  'Punjab',
  'Rajasthan',
  'Sikkim',
  'Tamil Nadu',
  'Telangana',
  'Tripura',
  'Uttarakhand',
  'Uttar Pradesh',
  'West Bengal',
  'Andaman and Nicobar Islands',
  'Chandigarh',
  'Dadra and Nagar Haveli',
  'Daman and Diu',
  'Delhi',
  'Lakshadweep',
  'Puducherry'
];
let numberFormat = function(number, width) {
  return (
    new Array(+width + 1 - (parseInt(number) + '').length).join('0') +
    parseInt(number)
  );
};
const passportUpload = props => {
  return (
    <Formik
      initialValues={{
        file: [],
        imgUrl: [],
        firstName: '',
        lastName: '',
        passport_no: '',
        file_no: '',
        address_line_1: '',
        address_line_2: '',
        city: '',
        state: {
          value: '',
          label: 'State'
        },
        pincode: '',
        pincodeCity: '',
        pincodeState: '',
        pincodError: '',
        pinCoderesolved: '',
        date: {
          value: '',
          label: 'Date'
        },
        month: {
          value: '',
          label: 'Month'
        },
        year: {
          value: '2001',
          label: '2001'
        },
        doiDate: {
          value: '',
          label: 'Date'
        },
        doiMonth: {
          value: '',
          label: 'Month'
        },
        doiYear: {
          value: '2001',
          label: '2001'
        },
        doeDate: {
          value: '',
          label: 'Date'
        },
        doeMonth: {
          value: '',
          label: 'Month'
        },
        doeYear: {
          value: '2001',
          label: '2001'
        },
        gender: '',
        currentAddress: false,
        PropertyType: false,
        OwnedBy: false,
        monthlyRent: '',
        source: 'Passport',
        address: '',
        UploadRent: 3
      }}
      validationSchema={validationSchema}
      onSubmit={(data, { setSubmitting, resetForm }) => {
        setSubmitting(true);
        props.handleSubmit();
      }}
    >
      {({
        values,
        data,
        setData,
        handleChange,
        errors,
        touched,
        handleBlur,
        setFieldError,
        setFieldValue,
        name,
        setFileUploadErrors,
        fileUploadErrors,
        setFieldTouched,
        handleSubmit
      }) => {
        const [skip, setSkip] = useState(false);
        const [uploadDone, setUploadDone] = useState(false);
        const [uploadExcepted, setUploadExcepted] = useState(false);
        const [pincodeError, setPincodeError] = useState(false);
        const [isSubmit, setSubmit] = useState(false);
        const [postSave, setPostSave] = useState(false);
        const [DocIdFront, setFrontDocId] = useState(false);
        const [docIdBack, setBackDocId] = useState(false);
        const [leadId, setLeadId] = useState(getApplicantionInfo().leadId);
        const [applicantId, setApplicantId] = useState(
          getApplicantionInfo().leadApplicantId
        );
        const [Loading, setLoading] = useState(false);
        const [show, setShow] = useState(true);
        const [fileUploadedTos3, setFileUploadedTos3] = useState(false);
        const [frontfileUploadedTos3, setFrontFileUploadedTos3] = useState(
          false
        );
        const [frontPage, setFront] = useState(false);
        const [backPage, setBack] = useState(false);
        const [AnyError, setAnyerrorOccued] = useState(false);
        const [PreviousData, setPreviousData] = useState(false);
        const [LoadingFail, setLoadingFail] = useState(false);
        useEffect(() => {
          if (frontfileUploadedTos3) {
            setUploadDone(true);
          }
        }, [fileUploadedTos3, frontfileUploadedTos3]);
        useEffect(() => {
          setLoading(true);
          GETAPI(leadId, applicantId, 'passport')
            .then(res => {
              let links = res.links;
              let front,
                back,
                frontDocId = 0,
                backdocId = 0;
              for (let i = 0; i < res.links.length; i++) {
                if (
                  links[i].docId &&
                  links[i].tag == 'passportFront' &&
                  links[i].docId > frontDocId
                ) {
                  frontDocId = links[i].docId;
                  front = links[i].url;
                } else if (
                  links[i].docId &&
                  links[i].tag == 'passportBack' &&
                  links[i].docId > backdocId
                ) {
                  backdocId = links[i].docId;
                  back = links[i].url;
                }
              }
              if (front) {
                setFieldValue('Pfront', front);
              }
              if (back) {
                setFieldValue('Pback', back);
              }
              setLoading(false);

              if (links.length != 0 && res.userData) {
                let userData = res.userData;
                if (userData) {
                  //let address = JSON.parse(userData?.address);
                  let dob = moment(userData?.dob);
                  let dateOfIssue = moment(userData?.dateOfIssue);
                  let dateOfExpiry = moment(userData?.dateOfExpiry);
                  setFieldValue('passport_no', userData?.passportNumber, ''),
                    setFieldValue('file_no', userData?.fileNumber, ''),
                    /*setFieldValue('address_line_1', address['line1'], ''),
                  setFieldValue('address_line_2', address['line2'], ''),
                  setFieldValue('city', address['city'], ''),
                  setFieldValue('state', {
                    label: address['state'],
                    value: address['state']
                  }),
                  setFieldValue('pincode', address['pinCode'], ''),*/
                    setFieldValue('firstName', userData?.firstName, ''),
                    setFieldValue('lastName', userData?.lastName, ''),
                    setFieldValue('gender', userData?.gender, '');
                  setFieldValue(
                    'month',
                    {
                      label: dob.format('MMMM'),
                      value: dob.format('MM')
                    },
                    ''
                  );
                  setFieldValue(
                    'date',
                    { label: dob.format('DD'), value: dob.format('DD') },
                    ''
                  );
                  setFieldValue(
                    'year',
                    { label: dob.format('YYYY'), value: dob.format('YYYY') },
                    ''
                  );
                  setFieldValue(
                    'doiMonth',
                    {
                      label: dateOfIssue.format('MMMM'),
                      value: dateOfIssue.format('MM')
                    },
                    ''
                  );
                  setFieldValue(
                    'doiDate',
                    {
                      label: dateOfIssue.format('DD'),
                      value: dateOfIssue.format('DD')
                    },
                    ''
                  );
                  setFieldValue(
                    'doiYear',
                    {
                      label: dateOfIssue.format('YYYY'),
                      value: dateOfIssue.format('YYYY')
                    },
                    ''
                  );
                  setFieldValue(
                    'doeMonth',
                    {
                      label: dateOfExpiry.format('MMMM'),
                      value: dateOfExpiry.format('MM')
                    },
                    ''
                  );
                  setFieldValue(
                    'doeDate',
                    {
                      label: dateOfExpiry.format('DD'),
                      value: dateOfExpiry.format('DD')
                    },
                    ''
                  );
                  setFieldValue(
                    'doeYear',
                    {
                      label: dateOfExpiry.format('YYYY'),
                      value: dateOfExpiry.format('YYYY')
                    },
                    ''
                  );
                }
                setPreviousData(true);
                setUploadDone(true);
                setUploadExcepted(true);
                setAnyerrorOccued(false);
                setSubmit(true);
              }
            })
            .catch(err => {
              setLoadingFail({
                message:
                  err?.response?.data?.message || 'Something went wrong !',
                status: err?.response?.data?.status
              });
            });
        }, []);
        useEffect(() => {
          if (values.file.length >= 1 && values.file[0]) {
            setLoading(true);
            UserKycUpload(
              values.file[0],
              leadId,
              applicantId,
              'passport',
              'passportFront'
            )
              .then(res => {
                UploadFileToS3(res.url, values.file[0][0]).then(res1 => {
                  setFrontFileUploadedTos3(true), setLoading(false);
                });
                setFrontDocId(res);
              })
              .catch(err => {
                setLoadingFail({
                  message:
                    err?.response?.data?.message || 'Something went wrong !',
                  status: err?.response?.data?.status
                });
              });
          }
        }, [values.file[0]]);

        useEffect(() => {
          if (values.file.length >= 2 && values.file[1]) {
            setLoading(true);
            UserKycUpload(
              values.file[1],
              leadId,
              applicantId,
              'passport',
              'passportBack'
            )
              .then(res => {
                UploadFileToS3(res.url, values.file[1][0]).then(res1 => {
                  setFileUploadedTos3(true);
                  setLoading(false);
                });
                setBackDocId(res);
              })
              .catch(err => {
                setLoadingFail({
                  message:
                    err?.response?.data?.message || 'Something went wrong !',
                  status: err?.response?.data?.status
                });
              });
          }
        }, [values.file[1]]);

        useEffect(() => {
          if (uploadExcepted && DocIdFront.requestId != undefined) {
            UserKycOcr(leadId, applicantId, DocIdFront.requestId, 'passport')
              .then(res => {
                let dob = res.kycEntries.dob.value.toString().split('/');
                let dateOfIssue = res.kycEntries.dateOfIssue.value
                  .toString()
                  .split('/');
                let dateOfExpiry = res.kycEntries.dateOfExpiry.value
                  .toString()
                  .split('/');
                setFieldValue(
                  'passport_no',
                  res.kycEntries.passportNumber.value
                );
                setFieldValue('gender', res.kycEntries.gender.value);
                setFieldValue(
                  'firstName',
                  res.kycEntries.firstMiddleName.value
                );
                setFieldValue('lastName', res.kycEntries.lastName.value);
                setFieldValue('year', { value: dob[2], label: dob[2] });
                setFieldValue('month', {
                  value: numberFormat(dob[1], 2),
                  label: dob[1]
                });
                setFieldValue('date', {
                  value: numberFormat(dob[0], 2),
                  label: dob[0]
                });
                setFieldValue('doiYear', {
                  value: dateOfIssue[2],
                  label: dateOfIssue[2]
                });
                setFieldValue('doiMonth', {
                  value: numberFormat(dateOfIssue[1], 2),
                  label: dateOfIssue[1]
                });
                setFieldValue('doiDate', {
                  value: numberFormat(dateOfExpiry[0], 2),
                  label: dateOfExpiry[0]
                });
                setFieldValue('doeYear', {
                  value: dateOfExpiry[2],
                  label: dateOfExpiry[2]
                });
                setFieldValue('doeMonth', {
                  value: numberFormat(dateOfExpiry[1], 2),
                  label: dateOfExpiry[1]
                });
                setFieldValue('doeDate', {
                  value: numberFormat(dateOfExpiry[0], 2),
                  label: dateOfExpiry[0]
                });
              })
              .catch(err => {
                setLoading(false);
              });
            UserKycOcr(leadId, applicantId, docIdBack.requestId, 'passport')
              .then(res => {
                let address = res.kycEntries.address.value
                  .toString()
                  .split(/,|- /);
                setFieldValue('file_no', res.kycEntries.fileNumber.value);
                for (let i = 0; i < address.length; i++) {
                  if (address[i]) {
                    for (let j = 0; j < StateList.length; j++) {
                      if (
                        address[i]
                          .toString()
                          .trim()
                          .toLowerCase() ==
                        StateList[j]
                          .toString()
                          .trim()
                          .toLowerCase()
                      ) {
                        setFieldValue('state', {
                          value: StateList[j],
                          label: StateList[j]
                        });
                        setFieldValue('city', address[i - 1]);
                      }
                    }
                    if (
                      !isNaN(address[i].toString().trim()) &&
                      address[i].toString().trim().length == 6
                    ) {
                      setFieldValue('pincode', address[i].toString().trim());
                    }
                  }
                }
                let address_1 = address,
                  address_2 = address;
                address_1 = address_1
                  .slice(1, parseInt(address.length / 2))
                  .join(',');
                address_2 = address_2
                  .slice(parseInt(address.length / 2), address.length)
                  .join(',');
                setFieldValue('address_line_1', address_1);
                setFieldValue('address_line_2', address_2);
                setFieldValue('address', address)
                  .then(e => setLoading(false))
                  .catch(err => setLoading(false));
              })
              .catch(err => setLoading(false));
          }
        }, [uploadExcepted]);
        const setToInitial = page => {
          setPreviousData(false);
          setUploadDone(true);
          setUploadExcepted(false);
          setAnyerrorOccued(false);
          setSubmit(false);
          if (page == 'front') setFront(true);
          if (page == 'back') setBack(true);
        };
        const SubmitAadharOCRData = () => {
          setLoading(true);
          let body = {
            fileNumber: values.file_no,
            passportNumber: values.passport_no,
            firstName: values.firstName,
            lastName: values.lastName,
            dob:
              values.year.value +
              '-' +
              values.month.value +
              '-' +
              values.date.value,
            dateOfIssue:
              values.doiYear.value +
              '-' +
              values.doiMonth.value +
              '-' +
              values.doiDate.value,
            dateOfExpiry:
              values.doeYear.value +
              '-' +
              values.doeMonth.value +
              '-' +
              values.doeDate.value,
            placeOfIssue: values.city,
            placeOfBirth: values.city,
            countryCode: values.state.value,
            passportType: ''
          };
          UserKycVarifyDetails(leadId, applicantId, body, 'passport')
            .then(e => {
              setLoading(false), props.handleSubmit();
            })
            .catch(err => {
              setLoadingFail({
                message:
                  err?.response?.data?.message || 'Something went wrong !',
                status: err?.response?.data?.status
              });
              setLoading(false);
            });
        };
        function getLoadingMsg() {
          if (typeof LoadingFail !== 'boolean') {
            if (LoadingFail) return LoadingFail?.message;
          }
          return <p>Loading ...</p>;
        }
        return (
          <div className="">
            <div className="block md:hidden w-full bg-purple-200 flex  py-4 rounded px-2 items-center">
              <div className="w-4/12 ">
                <img src={DocImage} />
              </div>
              <div className="w-7/12 block px-2 ">
                <p className="font-roboto font-normal text-blue-900">Step 3</p>
                <p className="font-roboto font-medium text-blue-900">
                  Now please upload Paassport
                </p>
              </div>
              <div className="ml-auto pr-3 text-blue-900  ">
                <img src={arrow_icon} />
              </div>
            </div>

            {!postSave ? (
              <Aadhar
                values={values}
                data={data}
                setData={setData}
                handleChange={handleChange}
                errors={errors}
                touched={touched}
                handleBlur={handleBlur}
                setFieldError={setFieldError}
                setFieldValue={setFieldValue}
                name={name}
                setFileUploadErrors={setFileUploadErrors}
                fileUploadErrors={fileUploadErrors}
                setFieldTouched={setFieldTouched}
                handleSubmit={handleSubmit}
                setToInitial={setToInitial}
              />
            ) : null}
            {uploadExcepted && !postSave ? (
              <AdhaarDataFields
                values={values}
                data={data}
                setData={setData}
                handleChange={handleChange}
                errors={errors}
                touched={touched}
                handleBlur={handleBlur}
                setFieldError={setFieldError}
                setFieldValue={setFieldValue}
                name={name}
                setFileUploadErrors={setFileUploadErrors}
                fileUploadErrors={fileUploadErrors}
                setFieldTouched={setFieldTouched}
              />
            ) : null}
            <div className="md:inset-x-0 md:bottom-0 md:py-5">
              {uploadDone ? (
                <button
                  type="button"
                  className="submitButton font-roboto text-white text-base w-48 "
                  disabled={
                    isSubmit
                      ? errors.firstName ||
                        values.firstName == '' ||
                        errors.passport_no ||
                        values.passport_no == '' ||
                        values.date.value == '' ||
                        values.month.value == '' ||
                        values.year.value == '' ||
                        values.doiYear.value == '' ||
                        values.doiDate.value == '' ||
                        values.doeMonth.value == '' ||
                        values.doeYear.value == '' ||
                        values.doeDate.value == '' ||
                        values.doiMonth.value == '' ||
                        errors.address_line_1 ||
                        values.address_line_1 == '' ||
                        errors.city ||
                        values.city == '' ||
                        values.state.value == '' ||
                        errors.pincode ||
                        values.pincode == '' ||
                        values.gender == ''
                      : null
                  }
                  onClick={() => {
                    if (values.currentAddress == 'no') {
                      handleSubmit();
                    }
                    if (
                      values.currentAddress == 'yes' &&
                      values.PropertyType != 'rented' &&
                      values.OwnedBy
                    ) {
                      handleSubmit();
                    }

                    if (values.PropertyType == 'rented' && values.monthlyRent) {
                      handleSubmit();
                    } else if (!isSubmit) {
                      setUploadExcepted(true), setSubmit(true);
                      setLoading(true);
                    } else if (isSubmit && !postSave) {
                      SubmitAadharOCRData();
                    }
                  }}
                >
                  {!isSubmit ? (
                    <>
                      <span className="hidden md:block">Upload</span>
                      <span className="md:hidden block">Next</span>
                    </>
                  ) : (
                    <span className="block">Save & Verify</span>
                  )}
                </button>
              ) : null}
            </div>
            {Loading ? (
              <PopUp
                goto={LoadingFail.status == 403}
                dontClose={LoadingFail?.status == 403}
                type={LoadingFail?.message ? 'fail' : 'loading'}
                text={getLoadingMsg()}
                setShow={setShow}
                show={true}
              />
            ) : null}
          </div>
        );
      }}
    </Formik>
  );
};

const Aadhar = props => {
  const {
    values,
    setData,
    handleChange,
    errors,
    touched,
    handleBlur,
    setFieldError,
    setFieldValue,
    name,
    setFileUploadErrors,
    fileUploadErrors,
    setFieldTouched,
    handleSubmit,
    setToInitial
  } = props;
  const setEditFront = () => {
    setFieldValue('Pfront', false), setToInitial('front');
  };

  const setEditBack = () => {
    setFieldValue('Pback', false), setToInitial('back');
  };
  return (
    <div className="w-full ">
      <div className="bg-grey-1008 md:bg-white  px-3 w-full py-5 rounded h-full  pb-9 md:pb-20  block shadow md:shadow-none">
        <div className="w-full flex py-5">
          <h2 className="font-roboto font-medium  text-base mr-auto text-black-1100">
            Upload Your Passport
          </h2>
        </div>
        <div className="bg-white border border-navy-200  md:border-0 w-full px-2 md:px-0 rounded-lg py-4 md:py-0">
          <p className="md:hidden block font-roboto font-normal text-grey-2100 mr-auto py-3 text-sm">
            Upload Your Passport
          </p>
          <div className=" w-full flex  flex-wrap lg:pr-4 lg:px-5 md:mx-auto justify-center">
            <div className=" block md:m-auto">
              {!values.Pfront ? (
                <GlobalUploadComp
                  data={values}
                  imgIndex={0} //0,1,2,3 depending upon the no of file sequence
                  errors={errors}
                  touched={touched}
                  handleChange={handleChange}
                  handleBlur={handleBlur}
                  setFieldValue={setFieldValue}
                  setFieldTouched={setFieldTouched}
                  setFieldError={setFieldError}
                  initialImg={initialImg} // initial image
                  subInst="Click here Upload Front Page of passport"
                  subtext="Upload Front"
                />
              ) : (
                <ShowGetImage img={values.Pfront} setEdit={setEditFront} />
              )}
            </div>
            <div className=" block md:m-auto">
              {!values.Pback ? (
                <GlobalUploadComp
                  data={values}
                  imgIndex={1} //0,1,2,3 depending upon the no of file sequence
                  errors={errors}
                  touched={touched}
                  handleChange={handleChange}
                  handleBlur={handleBlur}
                  setFieldValue={setFieldValue}
                  setFieldTouched={setFieldTouched}
                  setFieldError={setFieldError}
                  initialImg={initialImg} // initial image
                  subInst="Click here Upload Back Page of Passport"
                  subtext="Upload back"
                />
              ) : (
                <ShowGetImage img={values.Pback} setEdit={setEditBack} />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const AdhaarDataFields = props => {
  const {
    values,
    data,
    setData,
    handleChange,
    errors,
    touched,
    handleBlur,
    setFieldError,
    setFieldValue,
    name,
    setFileUploadErrors,
    fileUploadErrors,
    setFieldTouched
  } = props;
  const [gender, setGender] = useState('');
  const [pincodeDeatils, setPincodeDetails] = useState('');
  const [statusFilterList, setStatusFilterList] = useState([]);
  const [state, setState] = useState('');
  useEffect(() => {
    let StateListArray = [];

    StateList.sort().map(each =>
      StateListArray.push({
        label: each,
        value: each
      })
    );
    setStatusFilterList(StateListArray);
  }, []);

  return (
    <div className="bg-white md:px-10 py-8 md:py-1 p-4 md:p-2 ">
      <div className="flex-1  w-full">
        <p className="font-roboto font-normal text-grey-920 text-base ">
          Gender
        </p>
        <div className={' w-full flex '}>
          <div
            className={values.gender == 'MALE' ? 'assignedImg' : 'assignImg'}
            onClick={() => setFieldValue('gender', 'MALE')}
          >
            <img className="cursor-pointer px-2 " src={MaleImage} />
          </div>
          <div
            className={values.gender == 'FEMALE' ? 'assignedImg' : 'assignImg'}
            onClick={() => setFieldValue('gender', 'FEMALE')}
          >
            <img className="cursor-pointer px-2" src={Female} />
          </div>
          <div
            className={values.gender == 'transg' ? 'assignedImg' : 'assignImg'}
            onClick={() => setFieldValue('gender', 'transg')}
          >
            <img className="cursor-pointer px-2" src={common_gender} />
          </div>
        </div>
        {errors.gender ? <p className="text-red-100 pt-2">Required</p> : null}

        <div className="block py-10 ">
          <div className="w-full md:flex block">
            <div className="w-full md:w-5/12  py-3 ">
              <CommonInput
                name="firstname"
                disabled=""
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.firstName}
                stylesContainer={{
                  height: '52px',
                  maxWidth: '100%'
                }}
                legendName="First Name"
                error={touched.firstName && errors.firstName}
                errorMsg={errors.firstName}
                touched={touched.firstName}
              />
            </div>
            <div className="w-full md:w-5/12  py-3 mr-auto md:ml-7 ">
              <CommonInput
                name="lastName"
                disabled=""
                onChange={e => {
                  if (!isNaN(e.target.value) && e.target.value.length <= 12) {
                    handleChange(e);
                  }
                }}
                onBlur={handleBlur}
                value={values.lastName}
                stylesContainer={{
                  height: '52px',
                  maxWidth: '100%'
                }}
                legendName="Last Name"
                error={touched.lastName && errors.lastName}
                errorMsg={errors.lastName}
                touched={touched.lastName}
              />
            </div>
          </div>
          <div className="md:flex block">
            <div className="w-full lg:w-5/12  md:w-5/12  py-3  ">
              <div className="text-black-600 font-roboto font-normal text-xs pb-2">
                DOB
              </div>

              <CommonDatePicker
                onChangeMonth={(value, isValidDate) => {
                  setFieldValue('month', value, true);
                  setFieldTouched('month', true, false);
                  if (!isValidDate) {
                    setFieldValue(
                      'date',
                      {
                        value: '',
                        label: 'Date'
                      },
                      true
                    );
                  }
                }}
                onChangeYear={(value, isValidDate) => {
                  setFieldValue('year', value, true);
                  setFieldTouched('year', true, false);

                  if (!isValidDate) {
                    setFieldValue(
                      'date',
                      {
                        value: '',
                        label: 'Date'
                      },
                      true
                    );
                  }
                }}
                onChangeDate={value => {
                  setFieldValue('date', value, true);
                  setFieldTouched('date', true, false);
                }}
                valueMonth={values.month}
                valueYear={values.year}
                valueDate={values.date}
                errorYear={touched.year && get(errors, 'year.value', false)}
                touchedYear={touched.year}
                onBlurYear={() => {
                  setFieldTouched('year', true, true);
                }}
                errorMonth={touched.month && get(errors, 'month.value', false)}
                touchedMonth={touched.month}
                onBlurMonth={() => {
                  setFieldTouched('month', true, true);
                }}
                // errors.date.value
                errorDate={touched.date && get(errors, 'date.value', false)}
                touchedDate={touched.date}
                onBlurDate={() => {
                  setFieldTouched('date', true, true);
                }}
                //  errorMsg= "DOB is not selected"git
                type="dob"
              />
            </div>
            <div className="w-full lg:w-5/12  md:w-5/12  py-3 md:ml-7 ">
              <div className="text-black-600 font-roboto font-normal text-xs pb-2">
                Date of issue
              </div>

              <CommonDatePicker
                onChangeMonth={(value, isValidDate) => {
                  setFieldValue('doiMonth', value, true);
                  setFieldTouched('doiMonth', true, false);
                  if (!isValidDate) {
                    setFieldValue(
                      'doiDate',
                      {
                        value: '',
                        label: 'Date'
                      },
                      true
                    );
                  }
                }}
                onChangeYear={(value, isValidDate) => {
                  setFieldValue('doiYear', value, true);
                  setFieldTouched('doiYear', true, false);

                  if (!isValidDate) {
                    setFieldValue(
                      'doiDate',
                      {
                        value: '',
                        label: 'Date'
                      },
                      true
                    );
                  }
                }}
                onChangeDate={value => {
                  setFieldValue('doiDate', value, true);
                  setFieldTouched('doiDate', true, false);
                }}
                valueMonth={values.doiMonth}
                valueYear={values.doiYear}
                valueDate={values.doiDate}
                errorYear={touched.doiYear && get(errors, 'year.value', false)}
                touchedYear={touched.doiYear}
                onBlurYear={() => {
                  setFieldTouched('doiYear', true, true);
                }}
                errorMonth={
                  touched.doiMonth && get(errors, 'month.value', false)
                }
                touchedMonth={touched.doiMonth}
                onBlurMonth={() => {
                  setFieldTouched('doiMonth', true, true);
                }}
                // errors.date.value
                errorDate={touched.doiDate && get(errors, 'date.value', false)}
                touchedDate={touched.doiDate}
                onBlurDate={() => {
                  setFieldTouched('doiDate', true, true);
                }}
                //  errorMsg= "DOB is not selected"git
                //type="dob"
              />
            </div>
          </div>
          <div className="w-full md:w-11/12 py-3 md:pr-7">
            <div className="text-black-600 font-roboto font-normal text-xs pb-2">
              Date of Expiry
            </div>

            <CommonDatePicker
              onChangeMonth={(value, isValidDate) => {
                setFieldValue('doeMonth', value, true);
                setFieldTouched('doeMonth', true, false);
                if (!isValidDate) {
                  setFieldValue(
                    'doeDate',
                    {
                      value: '',
                      label: 'Date'
                    },
                    true
                  );
                }
              }}
              onChangeYear={(value, isValidDate) => {
                setFieldValue('doeYear', value, true);
                setFieldTouched('doeYear', true, false);

                if (!isValidDate) {
                  setFieldValue(
                    'doeDate',
                    {
                      value: '',
                      label: 'Date'
                    },
                    true
                  );
                }
              }}
              onChangeDate={value => {
                setFieldValue('doeDate', value, true);
                setFieldTouched('doeDate', true, false);
              }}
              valueMonth={values.doeMonth}
              valueYear={values.doeYear}
              valueDate={values.doeDate}
              errorYear={touched.doeYear && get(errors, 'year.value', false)}
              touchedYear={touched.doeYear}
              onBlurYear={() => {
                setFieldTouched('doeYear', true, true);
              }}
              errorMonth={touched.doeMonth && get(errors, 'month.value', false)}
              touchedMonth={touched.doeMonth}
              onBlurMonth={() => {
                setFieldTouched('doeMonth', true, true);
              }}
              // errors.date.value
              errorDate={touched.doeDate && get(errors, 'date.value', false)}
              touchedDate={touched.doeDate}
              onBlurDate={() => {
                setFieldTouched('doeDate', true, true);
              }}
              //  errorMsg= "DOB is not selected"git
              //type="dob"
            />
          </div>
          <div className="w-full md:flex block pt-5">
            <div className="w-full md:w-5/12  py-5  ">
              <CommonInput
                name="file_no"
                disabled=""
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.file_no}
                stylesContainer={{
                  height: '52px',
                  maxWidth: '100%'
                }}
                legendName="File Number"
                error={touched.file_no && errors.file_no}
                errorMsg={errors.file_no}
                touched={touched.file_no}
              />
            </div>
            <div className="w-full md:w-5/12 py-5 mr-auto md:ml-7 ">
              <CommonInput
                name="passport_no"
                disabled=""
                onChange={e => {
                  if (!isNaN(e.target.value) && e.target.value.length <= 12) {
                    handleChange(e);
                  }
                }}
                onBlur={handleBlur}
                value={values.passport_no}
                stylesContainer={{
                  height: '52px',
                  maxWidth: '100%'
                }}
                legendName="Passport Number"
                error={touched.passport_no && errors.passport_no}
                errorMsg={errors.passport_no}
                touched={touched.passport_no}
              />
            </div>
          </div>
          <div className="w-full md:flex block ">
            <div className="w-full md:w-5/12 py-5 ">
              <CommonInput
                name="address_line_1"
                disabled=""
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.address_line_1}
                stylesContainer={{
                  height: '52px',
                  maxWidth: '100%'
                }}
                legendName="Address Line 1"
                error={touched.address_line_1 && errors.address_line_1}
                errorMsg={errors.address_line_1}
                touched={touched.address_line_1}
              />
            </div>
            <div className="w-full md:w-5/12 py-5 mr-auto md:ml-7">
              <CommonInput
                name="address_line_2"
                disabled=""
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.address_line_2}
                stylesContainer={{
                  height: '52px',
                  maxWidth: '100%'
                }}
                legendName="Address Line 2"
                error={touched.address_line_2 && errors.address_line_2}
                errorMsg={errors.address_line_2}
                touched={touched.address_line_2}
              />
            </div>
          </div>
          <div className="w-full md:flex block  ">
            <div className="w-full md:w-5/12  py-2 md:py-9 ">
              <CommonInput
                name="city"
                disabled=""
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.city}
                stylesContainer={{
                  height: '52px',
                  maxWidth: '100%'
                }}
                legendName="City"
                error={touched.city && errors.city}
                errorMsg={errors.city}
                touched={touched.city}
              />
            </div>

            <div className="w-full md:w-5/12 mr-auto py-3 md:py-3  md:ml-7 ">
              <div className="text-black-600 font-roboto font-normal text-xs pb-2">
                State
              </div>

              <CommonSelect sort={true}
                name="state"
                value={values.state}
                onChange={e => {
                  setFieldValue('state', { value: e.value, label: e.value });
                }}
                options={statusFilterList}
                isHoverEffect
                stylesContainer={{
                  height: '52px',
                  marginBottom: '0px',
                  fontSize: '40px'
                }}
                dropdownStyle={{
                  top: '52px',
                  color: 'rgba(0,0,0,0.87)',
                  fontSize: '16px',
                  backgroundColor: '#fff',
                  alignItems: 'center',
                  fontFamily: 'Roboto',
                  fontWeight: 400
                }}
                styleText={{
                  fontSize: '14px',
                  padding: '0 25px'
                }}
                error={touched.state && get(errors, 'state.value', false)}
                touched={touched.state}
                onBlur={e => {
                  () => {};
                }}
              />
            </div>
          </div>
          <div className="w-full md:flex block ">
            <div className="md:w-5/12 mr-auto py-5 md:py-3">
              <CommonPincode
                name="pincode"
                value={values.pincode}
                onChange={e => {
                  if (e.target.value.length <= 6 && !isNaN(e.target.value)) {
                    handleChange(e);
                    setFieldValue('pinCoderesolved', false);
                  }
                }}
                stylesContainer={{
                  height: '52px',
                  maxWidth: '100%'
                }}
                error={
                  get(errors, 'pincode', false) &&
                  get(touched, 'pincode', false)
                }
                errorMsg={get(errors, 'pincode', false)}
                touched={get(touched, 'pincode', false)}
                onPinCodeSucessOrFailure={obj => {
                  const { err, data: pincodeData } = obj;

                  if (!err && pincodeData) {
                    setFieldValue('pinCoderesolved', true);
                    setFieldValue('pincodeCity', pincodeData.District),
                      setFieldValue('pincodeState', pincodeData.State);
                  } else {
                    setFieldError('pincode', 'Pincode is not valid');
                  }
                }}
                onBlur={e => {
                  handleBlur(e);
                }}
              />
              {values.pinCoderesolved || errors.pincode ? (
                <p
                  className={
                    (errors.pincode ? 'text-red-500' : 'text-green-500') +
                    ' pt-2 text-xs'
                  }
                >
                  {errors.pincode
                    ? null
                    : values.pincodeCity + ',   ' + values.pincodeState}
                </p>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default memo(passportUpload);
